class FormValidate {
    constructor (theme, elem) {
        this.name = 'FormValidate'
        this._theme = theme
        this._elem = elem
    }
    onInit () {
        const submitButton = this._elem.querySelector('[type="submit"]')
        if (submitButton) {
            submitButton.addEventListener('click', () => { this.validateForm() })
        }
        this._elem.addEventListener('submit', e => { this.onSubmit(e) })
        const fields = this._elem.querySelectorAll('input[required]')
        if (fields.length > 0) {
            for (let field of fields) {
                field.addEventListener('focus', () => { field.classList.remove('error') })
            }
        }
    }
    onSubmit (e) {
        const form = e.currentTarget
        e.preventDefault()
        let error = this.validateForm()
        if (!error) {
            form.submit()
        }
    }
    validateForm () {
        let error = false
        const fields = this._elem.querySelectorAll('input[required]')
        if (fields.length > 0) {
            for (let field of fields) {
                if (!field.value) {
                    error = true
                    field.classList.add('error')
                } else {
                    field.classList.remove('error')
                }
            }
        }
        return error
    }
}

export default FormValidate



// WEBPACK FOOTER //
// ./src/resources/scripts/components/FormValidate.js